module.exports = __webpack_public_path__ + "static/media/LawDroid_Voice_Logo.9f0ff98b.png";